export default __webpack_public_path__ + "static/media/dimg11.f8df3364.jpg";